"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Http call wrapping class that provides authenticated http operations.  Convenience methods fail the promises when response status >=400.
 * @class HttpService
 */
class HttpService {
    constructor(params) {
        this.http = params.http;
        this.tokenStore = params.tokenStore;
    }
    /**
     * Convenience method wrapping the fetch request for a GET.
     * @param {HttpMethodRequest} params request params
     */
    get(params) {
        return this.request({
            url: params.url,
            method: 'GET',
            headers: params.headers,
            body: params.body
        });
    }
    /**
     * Convenience method wrapping the fetch request for a POST.
     * @param {HttpMethodRequest} params request params
     */
    post(params) {
        return this.request({
            url: params.url,
            method: 'POST',
            headers: params.headers,
            body: params.body,
        });
    }
    /**
     * Convenience method wrapping the fetch request for a PUT.
     * @param {HttpMethodRequest} params request params
     */
    put(params) {
        return this.request({
            url: params.url,
            method: 'PUT',
            headers: params.headers,
            body: params.body,
        });
    }
    /**
     * Convenience method wrapping the fetch request for a DELETE.
     * @param {HttpMethodRequest} params request params
     */
    delete(params) {
        return this.request({
            url: params.url,
            method: 'DELETE',
            headers: params.headers,
            body: params.body,
        });
    }
    /**
     * Adds CloudLink authentication information to http requests.  Will attempt to refresh the token on a 401 and retry the operation if successful.
     * @param {HttpRequest} request
     */
    request(request) {
        const hasAuthHeader = this.hasAuthHeader(request);
        return this.getAuthenticatedOptions(request)
            .then(authenticatedParams => this.sendRequest(authenticatedParams))
            .catch(response => {
            if (response.statusCode === 401 && !hasAuthHeader) {
                return this.tokenStore.refresh()
                    .then(token => this.setAuthorizationHeader(token, request))
                    .then(authenticatedParams => this.sendRequest(authenticatedParams));
            }
            else {
                throw response;
            }
        });
    }
    getAuthenticatedOptions(request) {
        if (!this.hasAuthHeader(request)) {
            return this.tokenStore.getToken()
                .then(token => this.setAuthorizationHeader(token, request));
        }
        else {
            return Promise.resolve(request);
        }
    }
    setAuthorizationHeader(token, request) {
        return this.setHeader({
            request,
            header: 'authorization',
            value: !token ? undefined : `Bearer ${token.access_token}`,
        });
    }
    hasAuthHeader(request) {
        return this.hasHeader({ request, header: 'authorization' });
    }
    hasHeader(params) {
        const { request, header } = params;
        return !(!request.headers || !request.headers[header]);
    }
    setHeader(params) {
        const { request, header, value } = params;
        request.headers = request.headers || {};
        if (value) {
            request.headers[header] = value;
        }
        return request;
    }
    sendRequest(request) {
        return this.http.request(request);
    }
}
exports.HttpService = HttpService;
//# sourceMappingURL=http-service.js.map